import { render, staticRenderFns } from "./complaintOrder.vue?vue&type=template&id=5c082dff&scoped=true&"
import script from "./complaintOrder.vue?vue&type=script&lang=js&"
export * from "./complaintOrder.vue?vue&type=script&lang=js&"
import style0 from "./complaintOrder.vue?vue&type=style&index=0&id=5c082dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c082dff",
  null
  
)

export default component.exports